import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-8">
      <img
        src="/logo.png"
        alt="MoldOp"
        className="w-72 object-contain animate-in fade-in zoom-in-95 duration-700 ease-out mix-blend-multiply dark:mix-blend-normal"
      />
      <div className="w-36 h-[2px] rounded-full bg-border overflow-hidden">
        <div
          className="h-full w-1/3 rounded-full hot-runner"
          style={{ animation: 'slide-bar 1.4s cubic-bezier(0.4,0,0.2,1) infinite' }}
        />
      </div>
    </div>
  );

  if (!user) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
